import { render, staticRenderFns } from "./TambahSaldoPemilikSistem.vue?vue&type=template&id=3da04c60&scoped=true&"
import script from "./TambahSaldoPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./TambahSaldoPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da04c60",
  null
  
)

export default component.exports